import { useEffect } from 'react'

function useRefreshLocalStorage() {
  useEffect(() => {
    const lastRefreshTime = localStorage.getItem('lastRefreshTime')
    const currentTime = Date.now()

    if (!lastRefreshTime) {
      localStorage.setItem('lastRefreshTime', currentTime.toString())
    }

    const TIME_TO_REFRESH = 1000 * 60 * 60 * 8 // 8 hours
    const timeDiff = currentTime - lastRefreshTime
    const isTimeToRefresh = timeDiff >= TIME_TO_REFRESH

    if (isTimeToRefresh) {
      localStorage.setItem('lastRefreshTime', currentTime.toString())
      window.location.reload(true)
    }
  }, [])
}

export default useRefreshLocalStorage
